import { __decorate, __rest } from "tslib";
/**
 *  成交交付中
 */
import React, { Component } from 'react';
import { Table, Button, Row, Col, Select, Form, DatePicker } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer, showInfo, UnitSearch, DealType, TransferTypeStatus, BuyerDistributor, OperateShowMore, } from '@/components';
import { dispatch } from '@@/store';
import { dealListValueShow, dealValueShow, thousandBitSeparator } from '@/shared/functions';
import { showCarDetail } from '@/components/CarDetail';
import moment from 'moment';
import { dealTimeAnotherLine } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
import { useOperate } from '@/pages/OrderManage/_component/operateColumn';
import SignContract from '@/pages/OrderManage/_component/SignContract';
import { dealTableScroll } from './function';
const mapStateToProps = (rootState) => ({
    carState: rootState.carState,
});
// @ts-ignore
let TradingDelivery = class TradingDelivery extends Component {
    constructor(props) {
        super(props);
        const _this = this;
        this.state = {
            clipped: [
                { dataIndex: 'carVin' },
                { dataIndex: 'carLicense' },
                { dataIndex: 'carLocation' },
                { dataIndex: 'buyerTypeName' },
                { dataIndex: 'buyerTypeName' },
            ],
            colums: [
                {
                    title: '车辆信息',
                    dataIndex: 'carMsg',
                    width: 400,
                    fixed: 'left',
                    render: (carMsg, rowData, index) => {
                        const { firstImage, goodsName, goodsId, carVin, carLicense, carLocation, rankDesc, rankLevel, reportType } = rowData;
                        return (<div className={'lefe_right_layout'}>
                <div className={'img_item'}>
                  <img src={firstImage} alt={goodsName}/>
                </div>
                <div>
                  <div>
                    {goodsName ? <a onClick={() => {
                            showCarDetail(goodsId);
                        }}>
                        {goodsName}
                      </a> : fontEndConfig.noValueReplace}
                  </div>
                  <div>{`VIN码：${carVin}`}</div>
                  <div>
                    {reportType === 1 &&
                            <img className={'report_268v'} src={require('@/assets/report/268v_2.png')} alt="268v"/>}
                    <div className={'tag_item'}>{carLicense}</div>
                    <div className={'tag_item'}>{carLocation}</div>
                    <div className={'tag_item'}>
                      {dealValueShow((rankLevel + rankDesc) === 'undefined' ? fontEndConfig.noValueReplace : (rankLevel + rankDesc), false, fontEndConfig.noValueReplace)}
                    </div>
                    <div className={'tag_item'}>{this.getDealType(rowData.sourceType)}</div>
                  </div>
                </div>
              </div>);
                    },
                },
                {
                    title: '买卖家信息',
                    dataIndex: 'buyerSellerMsg',
                    width: 300,
                    render: (data, record, index) => {
                        const { buyerTypeName, sellerName, incomeModifyTime } = record;
                        return (<div>
                <div>{`买家类型：${buyerTypeName}`}</div>
                <BuyerDistributor record={record}/>
                <div>
                  <span>卖家经销商：</span>
                  {sellerName ? <a onClick={() => {
                            showInfo('seller', record.sellerCode);
                        }}>
                      {sellerName}
                    </a> : fontEndConfig.noValueReplace}
                </div>
                {_this.state.activeState === 'paying' && <div>{`买家付款时间：${incomeModifyTime}`}</div>}
              </div>);
                    },
                },
                {
                    title: '价格信息',
                    className: 'tableColumn__addYuan',
                    dataIndex: 'priceMsg',
                    width: 250,
                    render: (data, record, index) => {
                        return (<div>
                <div>{`成交价：${thousandBitSeparator(record.sellerPriceYuanUnit)}`}</div>
                <div>{`合手价：${thousandBitSeparator(record.totalPriceYuanUnit)}`}</div>
                <div style={{
                            fontSize: '10px',
                        }}>
                  {`佣金：${thousandBitSeparator(record.brokerageYuanUnit)}`}
                  &nbsp;&nbsp;
                  {`服务费：${thousandBitSeparator(record.commissionYuanUnit)}`}
                </div>
              </div>);
                    },
                },
            ],
            changeColumn: {
                dealSuccessTime: {
                    title: '成交时间',
                    dataIndex: 'createTime',
                    width: 200,
                    render: (overTime) => {
                        return overTime ? (dealTimeAnotherLine(overTime)) : fontEndConfig.noValueReplace;
                    },
                },
                showTransfer: {
                    title: '过户方式和状态',
                    dataIndex: 'transfer',
                    width: 250,
                    render(data, record) {
                        return <TransferTypeStatus record={record}/>;
                    },
                },
            },
            globalSearch: {},
            privateSearch: {
                unitSearch: {},
                waitSubscribe: {},
                waitPay: {},
                paying: {},
            },
            activeState: 'waitSubscribe',
            stateList: [
                {
                    label: '待买家签署合同',
                    key: 'waitSubscribe',
                },
                {
                    label: '待付款车辆',
                    key: 'waitPay',
                },
                {
                    label: '交付中车辆',
                    key: 'paying',
                },
            ],
            unitList: [
                {
                    label: '买家经销商名称',
                    key: 'buyerName',
                },
                {
                    label: '买家经销商电话',
                    key: 'buyerPhone',
                },
            ],
            userTypeList: [
                {
                    label: '全部',
                    key: '',
                },
                {
                    label: '网络',
                    key: 1,
                },
                {
                    label: '现场',
                    key: 0,
                },
            ],
            payStateList: [
                {
                    label: '全部',
                    value: '',
                },
                {
                    label: '待申请',
                    value: '0',
                },
                {
                    label: '待确认',
                    value: '1',
                },
            ],
        };
        this.updateCurrentIndex = this.updateCurrentIndex.bind(this);
        this.getTableOperateColumn = this.getTableOperateColumn.bind(this);
        this.updateTable = this.updateTable.bind(this);
    }
    componentDidMount() {
        dispatch.carState.getEveryStateCarNum({});
        this.searchData(this.props.search);
    }
    // 成交状态
    getDealType(data) {
        switch (data) {
            case 1:
                return '流拍撮合';
            case 2:
                return '撮合成交';
            case 0:
            default:
                return '正常成交';
        }
    }
    // desc更新表格内容
    updateTable(index) {
        const { activeState } = this.state;
        this[`${activeState}Search`](index);
    }
    waitSubscribeSearch(index) {
        dispatch.carState.updateWaitSubscribe(index);
    }
    waitPaySearch(index) {
        dispatch.carState.updateWaitPay(index);
    }
    payingSearch(index) {
        dispatch.carState.updatePaying(index);
    }
    search() {
        const { globalSearch, privateSearch, activeState } = this.state;
        const { unitSearch, waitSubscribe, waitPay, paying } = privateSearch, otherPrivate = __rest(privateSearch, ["unitSearch", "waitSubscribe", "waitPay", "paying"]);
        const _a = privateSearch[activeState], { startTime, endTime } = _a, otherStateData = __rest(_a, ["startTime", "endTime"]);
        let dealSearch = {};
        if (startTime && endTime) {
            const startTimeStr = startTime.format('YYYY-MM-DD');
            const endTimeStr = endTime.format('YYYY-MM-DD');
            switch (activeState) {
                case 'waitSubscribe':
                    dealSearch = {
                        tradeDateStar: startTimeStr,
                        tradeDateEnd: endTimeStr,
                    };
                    break;
                case 'waitPay':
                    dealSearch = {
                        tradeDateStar: startTimeStr,
                        tradeDateEnd: endTimeStr,
                    };
                    break;
                case 'paying':
                    dealSearch = {
                        buyerPayDateStar: startTimeStr,
                        buyerPayDateEnd: endTimeStr,
                    };
                    break;
            }
        }
        const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, globalSearch), unitSearch), dealSearch), otherPrivate), otherStateData);
        console.log(params);
        dispatch.carState.SET_STATE({
            searchData: params,
        });
        this[`${activeState}Search`](1);
    }
    searchData(searchData) {
        const { vin } = searchData, otherSearch = __rest(searchData, ["vin"]);
        this.setState({
            globalSearch: Object.assign(Object.assign({}, otherSearch), { vinCode: vin }),
        }, () => {
            this.search();
        });
    }
    getTableOperateColumn(key) {
        const updatedFn = () => {
            this.updateCurrentIndex();
            dispatch.carState.getEveryStateCarNum({});
        };
        return {
            title: '操作',
            dataIndex: 'operate',
            width: 150,
            fixed: 'right',
            render(data, record) {
                return (<OperateShowMore>
            {useOperate({
                    pageIdentification: key,
                    record,
                    orderCallback: updatedFn,
                })}
            <a onClick={() => {
                    dispatch.router.push({
                        path: '/carManage/OfferCeneList',
                        query: {
                            id: record.auctionId,
                            gd: record.goodsId,
                        },
                    });
                }}>
              竞拍记录
            </a>
          </OperateShowMore>);
            },
        };
    }
    updateCurrentIndex() {
        const { activeState } = this.state;
        const { pageIndex } = this.props.carState;
        this[`${activeState}Search`](pageIndex);
        dispatch.carState.getEveryStateCarNum({});
    }
    getTableColumn() {
        const { colums, activeState, changeColumn, } = this.state;
        let tableColumns = [];
        switch (activeState) {
            case 'waitSubscribe':
                tableColumns = [...colums, changeColumn.dealSuccessTime, this.getTableOperateColumn('waitSignContract')];
                break;
            case 'waitPay':
                tableColumns = [...colums, changeColumn.dealSuccessTime, this.getTableOperateColumn('waitPayCar')];
                break;
            case 'paying':
                tableColumns = [...colums, changeColumn.showTransfer, this.getTableOperateColumn('waitTransfer')];
                break;
        }
        return tableColumns;
    }
    render() {
        const { tableData, isLoading, pageIndex, pageSize, tableTotal, searchData, } = this.props.carState;
        const { stateList, unitList, userTypeList, clipped, activeState, payStateList, privateSearch, } = this.state;
        const { startTime, endTime, buyerTypeCode, sourceType, confirmReceivables } = privateSearch[activeState];
        const time = startTime && endTime ? [startTime, endTime] : [];
        const tableColumns = this.getTableColumn();
        const { dealColumns, scrollX } = dealTableScroll(tableColumns);
        let exportType = '';
        switch (activeState) {
            case 'waitSubscribe':
                exportType = 'order_wait_contract';
                break;
            case 'waitPay':
                exportType = 'order_wait_pay';
                break;
            case 'paying':
                exportType = 'order_wait_transfer';
                break;
        }
        return (<React.Fragment>
        <Row gutter={16} align={'middle'} type={'flex'} justify={'start'} style={{
            marginBottom: '22px',
        }}>
          {stateList.map(({ label, key }) => {
            return (<Button key={`btn_${key}`} type={activeState === key ? 'primary' : undefined} style={{
                border: 0,
            }} onClick={() => {
                this.setState({
                    activeState: key,
                }, () => {
                    dispatch.carState.resetTableData();
                    this.search();
                });
            }}>
                  {label}
                </Button>);
        })}
          <Col span={6}>
            <UnitSearch queryList={unitList} onChange={(val) => {
            const { privateSearch } = this.state;
            const unitSearch = {};
            if (val) {
                const [searchKey, searchContent] = val.split('_');
                unitSearch[searchKey] = searchContent;
            }
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { unitSearch }),
            }, () => {
                this.search();
            });
        }}/>
          </Col>
        </Row>
        <TableContainer hasExport={true} exportObj={{
            type: 'order',
            params: Object.assign(Object.assign({}, searchData), { totalCount: tableTotal, exportType }),
            fileName: '车辆管理-成交交付中',
            allow: 'psgjb-carpendcjjfz-export',
        }}>
          <Row gutter={16} align={'middle'} type={'flex'} justify={'start'} style={{
            marginRight: '100px',
        }}>
            <Col span={8}>
              <Form.Item label={activeState !== 'paying' ? '成交时间' : '付款时间'} colon={false} className={'search_time_label_border form_date_width_100'}>
                <DatePicker.RangePicker placeholder={['开始时间', '结束时间']} className={'width-100'} value={time} disabledDate={(currentDate) => {
            const now = moment();
            return currentDate > now;
        }} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} onChange={(dates) => {
            const [startTime, endTime] = dates;
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { [activeState]: Object.assign(Object.assign({}, privateSearch[activeState]), { startTime,
                        endTime }) }),
            }, () => {
                this.search();
            });
        }}/>
              </Form.Item>
            </Col>
            <Col span={5}>
              <Select style={{
            width: '100%',
        }} value={buyerTypeCode} placeholder={'请选择买家类型'} onChange={(val) => {
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { [activeState]: Object.assign(Object.assign({}, privateSearch[activeState]), { buyerTypeCode: val }) }),
            }, () => {
                this.search();
            });
        }}>
                {userTypeList.map(({ label, key }) => {
            return (<Select.Option value={key} key={key}>{label}</Select.Option>);
        })}
              </Select>
            </Col>
            <Col span={5}>
              <DealType style={{
            width: '100%',
        }} value={sourceType} placeholder={'请选择成交类型'} onChange={(val) => {
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { [activeState]: Object.assign(Object.assign({}, privateSearch[activeState]), { sourceType: val }) }),
            }, () => {
                this.search();
            });
        }}/>
            </Col>
            {activeState === 'waitPay' && (<Col span={5}>
                  <Select value={confirmReceivables} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} style={{
            width: '100%',
        }} placeholder={'请选择收款状态'} onChange={(val) => {
            const { privateSearch } = this.state;
            this.setState({
                privateSearch: Object.assign(Object.assign({}, privateSearch), { waitPay: Object.assign(Object.assign({}, privateSearch.waitPay), { confirmReceivables: val }) }),
            }, () => {
                this.search();
            });
        }}>
                    {payStateList.map((item) => {
            return (<Select.Option value={item.value} key={item.value}>{item.label}</Select.Option>);
        })}
                  </Select>
                </Col>)}
          </Row>
          <Table loading={isLoading} className={'draw_table_all_border scroll_table'} columns={dealColumns} dataSource={dealListValueShow({
            gistData: clipped,
            data: tableData,
        })} scroll={{
            x: scrollX,
        }} rowKey={'orderId'} pagination={{
            current: pageIndex,
            pageSize,
            showQuickJumper: true,
            total: tableTotal,
            onChange: this.updateTable,
            showTotal: total => `共${total}条`,
        }}/>
        </TableContainer>
        {activeState === 'waitSubscribe' && <SignContract />}
      </React.Fragment>);
    }
};
TradingDelivery = __decorate([
    connect(mapStateToProps, null, null, { forwardRef: true })
], TradingDelivery);
export default TradingDelivery;
